import React from 'react'

const GlobalFilter = ({filter, setFilter}) => {
  return (
    <span>
        <input className='inputHledej' placeholder='Hledaný výraz' value={filter || ''} onChange={(e) => setFilter(e.target.value)} />
    </span>
  )
}

export default GlobalFilter